import { useTranslation } from "react-i18next";
import { translate as tr } from "../../i18n";
import LanguageSelector from "../common/LanguageSelector";
import React, { useEffect, useRef, useState } from "react";
import SideBar from "../common/sidebar";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { Modal, Button, ListGroup } from "react-bootstrap";
import moment from "moment";
import { loadUser } from "../../actions/auth";
import { useNavigate } from "react-router-dom";
import Loader from "../common/loader";
import Footer from "../common/footer";
import ToggleButton from "../common/togglebutton";
import "../../assets/css/settings.css";
import "../../assets/css/profile.css";

export default function ProfilePage() {
  useTranslation();
  const dispatch = useDispatch();
  const history = useNavigate();
  const auth     = useSelector((state) => state.auth);

  // ── Profile fields ──
  const [profile_name, setProfileName]   = useState("");
  const [email, setEmail]                = useState("");
  const [savedEmail, setSavedEmail]      = useState("");
  const [emailPassword, setEmailPassword] = useState("");
  const [country, setCountry]            = useState("");
  const [countries, setCountries]        = useState([]);
  const [errors, setErrors]              = useState({});

  // ── Save feedback ──
  const [nameSaved, setNameSaved]   = useState(false);
  const [emailSaved, setEmailSaved] = useState(false);
  const [passChanged, setPassChanged] = useState(false);

  // ── Password modal ──
  const [show, setShow]             = useState(false);
  const [password, setPassword]     = useState("");
  const [newPass, setNewPass]       = useState("");
  const [confirmPass, setConfirmPass] = useState("");

  // ── Notifications ──
  const [notification_long_run, setNotification] = useState(false);
  const [long_run_email, setLongRunEmail]       = useState(false);
  const [send_weekly_report, setWeeklyReport]     = useState(false);
  const [send_daily_report, setDailyReport]       = useState(false);
  const [dailyReportEmail, setDailyReportEmail]   = useState('');
  const [dailyReportEmailSaved, setDailyReportEmailSaved] = useState(false);
  const [send_news_letter, setNewsLetter]         = useState(false);
  const [is_group_similar, setGroupSimilar]       = useState(false);

  // ── Time & date dropdowns ──
  const [openZoneDD, selectOpenZone]         = useState(false);
  const [openDateFormatDD, setDateFormatDD]  = useState(false);
  const [openTimeFormatDD, setTimeFormatDD]  = useState(false);
  const [openFirstDayDD, setFirstDayDD]      = useState(false);
  const [openTimeDurationDD, setTimeDurationDD] = useState(false);
  const [openCountry, setOpenCountryList]    = useState(false);
  const [timeZone, setTimeZone]                       = useState("");
  const [dateFormat, setDateFormat]                   = useState("");
  const [timeFormat, setTimeFormat]                   = useState("");
  const [firstDay, setFirstDay]                       = useState(0);
  const [timeDurationFormat, setTimeDurationFormat]   = useState("");
  const [timeZonesList, setTimeZoneList]               = useState([]);
  const [tzSearch, setTzSearch]                       = useState("");
  const [countrySearch, setCountrySearch]             = useState("");

  // ── Avatar ──
  const [state, setState]       = useState({ file: null, fileName: null });
  const [openImg, setOpenImg]   = useState(false);
  const [urlImage, setUrlImage] = useState(false);
  const [isUploading, setUploading] = useState(false);

  // ── Sign-in options ──
  const [is_google_signin, setGoogleSignIn] = useState(false);
  const [is_apple_signin, setAppleSignIn]   = useState(false);

  // ── Close account modal ──
  const [openAccountModal, SetOpenAccountmodal] = useState(false);

  // ── Refs for dropdown outside-click ──
  const countryRef    = useRef(null);
  const tzRef         = useRef(null);
  const durationRef   = useRef(null);
  const dateFormatRef = useRef(null);
  const timeFormatRef = useRef(null);
  const firstDayRef   = useRef(null);

  // ── Static option lists ──
  const dateformats    = ["MM/DD/YYYY", "DD-MM-YYYY", "MM-DD-YYYY", "YYYY-MM-DD", "DD/MM/YYYY", "DD.MM.YYYY"];
  const timeFormats    = ["12-hour", "24-hour"];
  const days           = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const durationFormat = ["Classic (47:06 min)", "Improved (0:47:06)", "Decimal (0.79 h)"];

  const filteredZones = tzSearch
    ? timeZonesList.filter((z) => z.label.toLowerCase().includes(tzSearch.toLowerCase()))
    : timeZonesList;

  const filteredCountries = countrySearch
    ? countries.filter((c) => c.country_name.toLowerCase().includes(countrySearch.toLowerCase()))
    : countries;

  // ── Lifecycle ──
  useEffect(() => {
    function handleClickOutside(e) {
      if (countryRef.current    && !countryRef.current.contains(e.target))    { setOpenCountryList(false); setCountrySearch(""); }
      if (tzRef.current         && !tzRef.current.contains(e.target))         { selectOpenZone(false); setTzSearch(""); }
      if (durationRef.current   && !durationRef.current.contains(e.target))   setTimeDurationDD(false);
      if (dateFormatRef.current && !dateFormatRef.current.contains(e.target)) setDateFormatDD(false);
      if (timeFormatRef.current && !timeFormatRef.current.contains(e.target)) setTimeFormatDD(false);
      if (firstDayRef.current   && !firstDayRef.current.contains(e.target))   setFirstDayDD(false);
    }
    document.addEventListener("mousedown", handleClickOutside);
    getProfile();
    getAllTimeZones();
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ── Data fetching ──
  const getAllTimeZones = () => {
    const tzOptions = moment.tz
      .names()
      .map((name) => {
        const zone = moment.tz.zone(name);
        return { name, offset: zone !== null ? zone.utcOffset(Date.now()) : 0 };
      })
      .sort((a, b) => (a.offset === b.offset ? a.name.localeCompare(b.name) : b.offset - a.offset))
      .map((zone) => ({
        value: zone.name,
        label: `${zone.name} - (GMT${moment.tz(zone.name).format("Z")})`,
      }));
    setTimeZoneList(tzOptions);
  };

  const getProfile = async () => {
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      const body   = JSON.stringify({ workspace_id: auth.workspace_id });
      const res    = await axios.post("/api/profile/settings", body, config);
      if (res.status === 200) {
        const user  = res.data.results[0][0];
        const props = res.data.results[1][0];
        setUrlImage(is_url(user.avatar));
        setState({ fileName: user.avatar });
        setProfileName(`${user.first_name} ${user.last_name}`);
        setEmail(user.email);
        setSavedEmail(user.email);
        setCountry(res.data.results[0][0].country_name);
        setCountries(res.data.results[2]);
        setGoogleSignIn(user.is_google_signin === 1);
        setAppleSignIn(user.is_apple_signin === 1);
        setGroupSimilar(props.is_group_similar_entries === 1);
        setNotification(props.notification_long_run === 1);
        setLongRunEmail(props.send_long_run_email === 1);
        setWeeklyReport(props.send_weekly_report === 1);
        setDailyReport(props.send_daily_report === 1);
        setDailyReportEmail(props.daily_report_email || '');
        setNewsLetter(props.send_newsletter === 1);
        setTimeZone(props.timeZone);
        setDateFormat(props.dateFormat);
        setFirstDay(props.firstDayOfWeek);
        setTimeDurationFormat(props.timeDurationFormat);
        setTimeFormat(props.timeFormat);
      }
    } catch (err) { if (err.response) console.log(err.response); }
  };

  // ── Validation (field-scoped) ──
  const validateName = () => {
    const err = {};
    if (!profile_name.trim()) {
      err.profile_name = "Please enter your name";
    } else if (profile_name.trim().split(" ").filter(Boolean).length < 2) {
      err.profile_name = "Please enter first and last name";
    }
    setErrors((prev) => ({ ...prev, profile_name: err.profile_name }));
    return !err.profile_name;
  };

  const validateEmail = () => {
    const err     = {};
    const pattern = /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
    if (!email)                  err.email = "Please enter your email address.";
    else if (!pattern.test(email)) err.email = "Please enter a valid email address.";
    setErrors((prev) => ({ ...prev, email: err.email }));
    return !err.email;
  };

  const validatePassword = () => {
    const err    = {};
    const strong = /^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&]).*$/;
    if (!password)               err.password    = "Current password is required.";
    else if (!strong.test(password)) err.password = "Must be 8+ chars with uppercase, number and symbol.";
    if (!newPass)                err.newPass     = "New password is required.";
    else if (!strong.test(newPass))  err.newPass  = "Must be 8+ chars with uppercase, number and symbol.";
    if (confirmPass !== newPass) err.confirmPass = "Passwords do not match.";
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  // ── Profile field saves ──
  const changeName = async () => {
    if (!validateName()) return;
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      const arr    = profile_name.trim().split(" ");
      const first_name = arr[0];
      const last_name  = arr.length > 2 ? profile_name.substr(profile_name.indexOf(" ") + 1) : arr[1];
      const res = await axios.put("/api/profile/edit_name", JSON.stringify({ first_name, last_name, workspace_id: auth.workspace_id }), config);
      if (res.status === 200) {
        setNameSaved(true);
        setTimeout(() => setNameSaved(false), 2000);
        getProfile();
      }
    } catch (err) { if (err.response) console.log(err.response); }
  };

  const changeEmail = async () => {
    if (!validateEmail()) return;
    if (!emailPassword) {
      setErrors((prev) => ({ ...prev, emailPassword: "Please enter your current password." }));
      return;
    }
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      const res = await axios.put(
        "/api/profile/edit_email",
        JSON.stringify({ email, current_password: emailPassword, workspace_id: auth.workspace_id }),
        config
      );
      if (res.status === 200) {
        setEmailPassword("");
        setErrors((prev) => ({ ...prev, email: undefined, emailPassword: undefined }));
        setEmailSaved(true);
        setTimeout(() => setEmailSaved(false), 2000);
        getProfile();
      }
    } catch (err) {
      const e = err.response?.data?.errors?.[0];
      if (e?.password) setErrors((prev) => ({ ...prev, emailPassword: e.password }));
      else if (e?.email) setErrors((prev) => ({ ...prev, email: e.email }));
      else if (e?.msg) setErrors((prev) => ({ ...prev, email: e.msg }));
    }
  };

  const changePassword = async () => {
    if (!validatePassword()) return;
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      const res = await axios.put(
        "/api/profile/edit_password",
        JSON.stringify({ current_password: password, new_password: newPass, workspace_id: auth.workspace_id }),
        config
      );
      if (res.status === 200) {
        setShow(false);
        setPassword(""); setNewPass(""); setConfirmPass("");
        setErrors({});
        setPassChanged(true);
        setTimeout(() => setPassChanged(false), 2500);
      }
    } catch (err) {
      if (err.response?.data?.errors?.length > 0) {
        setErrors({ password: err.response.data.errors[0].password });
      }
      if (err.response) console.log(err.response);
    }
  };

  // ── Notification toggles ──
  const notificationChange = async () => {
    const next = !notification_long_run;
    setNotification(next);
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      await axios.put("/api/profile/update_long_notification", JSON.stringify({ long_run_notification: next ? 1 : 0, workspace_id: auth.workspace_id }), config);
    } catch (err) { setNotification(!next); if (err.response) console.log(err.response); }
  };

  const longRunEmailChange = async () => {
    const next = !long_run_email;
    setLongRunEmail(next);
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      await axios.put("/api/profile/update_long_run_email", JSON.stringify({ long_run_email: next ? 1 : 0, workspace_id: auth.workspace_id }), config);
    } catch (err) { setLongRunEmail(!next); if (err.response) console.log(err.response); }
  };

  const weeklyReportChange = async () => {
    const next = !send_weekly_report;
    setWeeklyReport(next);
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      await axios.put("/api/profile/update_weekly_report", JSON.stringify({ weekly_report: next ? 1 : 0, workspace_id: auth.workspace_id }), config);
    } catch (err) { setWeeklyReport(!next); if (err.response) console.log(err.response); }
  };

  const dailyReportChange = async () => {
    const next = !send_daily_report;
    setDailyReport(next);
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      await axios.put("/api/profile/update_daily_report", JSON.stringify({ daily_report: next ? 1 : 0, workspace_id: auth.workspace_id }), config);
    } catch (err) { setDailyReport(!next); if (err.response) console.log(err.response); }
  };

  const saveDailyReportEmail = async () => {
    const value = dailyReportEmail.trim();
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      await axios.put("/api/profile/update_daily_report_email", JSON.stringify({ daily_report_email: value, workspace_id: auth.workspace_id }), config);
      setDailyReportEmail(value);
      setDailyReportEmailSaved(true);
      setTimeout(() => setDailyReportEmailSaved(false), 1800);
    } catch (err) { if (err.response) console.log(err.response); }
  };

  const newsLetterChange = async () => {
    const next = !send_news_letter;
    setNewsLetter(next);
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      await axios.put("/api/profile/update_send_newsletter", JSON.stringify({ news_letter: next ? 1 : 0, workspace_id: auth.workspace_id }), config);
    } catch (err) { setNewsLetter(!next); if (err.response) console.log(err.response); }
  };

  const groupSimilarEntries = async (value) => {
    const next = !value;
    setGroupSimilar(next);
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      await axios.put("/api/profile/group_similar", JSON.stringify({ group_similar: next ? 1 : 0, workspace_id: auth.workspace_id }), config);
    } catch (err) { setGroupSimilar(value); if (err.response) console.log(err.response); }
  };

  // ── Country ──
  const selectCountry = async (item) => {
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      const res = await axios.put("/api/profile/edit_country", JSON.stringify({ country: item.country_id, workspace_id: auth.workspace_id }), config);
      if (res.status === 200) {
        setCountry(item.country_name);
        setOpenCountryList(false);
      }
    } catch (err) { if (err.response) console.log(err.response); }
  };

  // ── Time & date selectors ──
  const selectTimeZone = async (item) => {
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      const res = await axios.put("/api/profile/update_timeZone", JSON.stringify({ timeZone: item.label, workspace_id: auth.workspace_id }), config);
      if (res.status === 200) {
        setTimeZone(item.label);
        selectOpenZone(false);
        setTzSearch("");
        await restoreReduxStore(item.label, "timezone");
      }
    } catch (err) { if (err.response) console.log(err.response); }
  };

  const selectDateFormat = async (item) => {
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      const res = await axios.put("/api/profile/update_dateFormat", JSON.stringify({ dateFormat: item, workspace_id: auth.workspace_id }), config);
      if (res.status === 200) { setDateFormat(item); setDateFormatDD(false); await restoreReduxStore(item, "dateformat"); }
    } catch (err) { if (err.response) console.log(err.response); }
  };

  const selectTimeFormat = async (item) => {
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      const res = await axios.put("/api/profile/update_timeFormat", JSON.stringify({ timeFormat: item, workspace_id: auth.workspace_id }), config);
      if (res.status === 200) { setTimeFormat(item); setTimeFormatDD(false); await restoreReduxStore(item, "timeformat"); }
    } catch (err) { if (err.response) console.log(err.response); }
  };

  const selectTimeDuration = async (item) => {
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      const res = await axios.put("/api/profile/update_timeDurationFormat", JSON.stringify({ timeDurationFormat: item, workspace_id: auth.workspace_id }), config);
      if (res.status === 200) { setTimeDurationFormat(item); setTimeDurationDD(false); await restoreReduxStore(item, "timedurationformat"); }
    } catch (err) { if (err.response) console.log(err.response); }
  };

  const selectFirstDay = async (item, index) => {
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      const res = await axios.put("/api/profile/update_firstDayOfWeek", JSON.stringify({ firstDayOfWeek: index, workspace_id: auth.workspace_id }), config);
      if (res.status === 200) { setFirstDay(index); setFirstDayDD(false); await restoreReduxStore(index, "firstday"); }
    } catch (err) { if (err.response) console.log(err.response); }
  };

  const restoreReduxStore = async (data, id) => {
    const p = auth.user_properties || {};
    const base = {
      token: auth.token, workspace_id: auth.workspace_id,
      is_workspace_admin: auth.is_workspace_admin, user_id: auth.user_id, confirmation: true,
        user_properties: {
          dateFormat:           p.dateFormat           || "DD-MM-YYYY",
          firstDayOfWeek:       p.firstDayOfWeek       ?? 0,
          notification_long_run: p.notification_long_run ?? 0,
          send_long_run_email:   p.send_long_run_email   ?? 0,
          timeDurationFormat:   p.timeDurationFormat   || tr("Improved (0:47:06)"),
          timeFormat:           p.timeFormat           || tr("12-hour"),
          timeZone:             p.timeZone             || "",
        },
      };
    const overrides = {
      timezone:            { timeZone:           data },
      dateformat:          { dateFormat:         data },
      timeformat:          { timeFormat:         data },
      timedurationformat:  { timeDurationFormat: data },
      firstday:            { firstDayOfWeek:     data },
    };
    if (!overrides[id]) return;
    base.user_properties = { ...base.user_properties, ...overrides[id] };
    await dispatch(loadUser({ data: base }));
  };

  // ── Sign-in options ──
  const manageAdditionalSignIn = async (id, currentValue) => {
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      const res = await axios.put(
        "/api/profile/change_signin_option",
        JSON.stringify({ id, changed_signin_option: currentValue ? 0 : 1, workspace_id: auth.workspace_id }),
        config
      );
      if (res.status === 200) {
        if (id === 1) setGoogleSignIn(!currentValue);
        else if (id === 2) setAppleSignIn(!currentValue);
      }
    } catch (err) { if (err.response) console.log(err.response); }
  };

  // ── Avatar ──
  const onInputChange = (e) => setState({ file: e.target.files[0] });
  const imgClick   = () => setOpenImg(true);
  const closeImg   = () => { setErrors({}); setOpenImg(false); getProfile(); };

  const is_url = (str) => {
    if (!str) return false;
    return /^(?:https?|ftp):\/\//.test(str);
  };

  const profileImageSrc = (avatar) => {
    if (!avatar) return "";
    if (is_url(avatar)) return avatar;
    const cloudinaryBase = process.env.REACT_APP_CLOUDINARY_URL || "https://res.cloudinary.com/dg0lt9e0q/image/upload";
    return `${cloudinaryBase}${avatar.startsWith("/") ? "" : "/"}${avatar}`;
  };

  const validateImage = () => {
    const fileSize = 1024 * 1024 * 2;
    const allowed  = ["jpeg", "jpg", "png"];
    const err      = {};
    if (!state.file)                              { err.input_file = "Please select a file."; }
    else if (!state.file.type.includes("image"))  { err.input_file = "File is not an image."; }
    else if (!allowed.includes(state.file.type.split("/")[1])) { err.input_file = "Only JPEG and PNG are accepted."; }
    else if (state.file.size >= fileSize)         { err.input_file = "Image must be smaller than 2 MB."; }
    if (err.input_file) { setErrors(err); return false; }
    return true;
  };

  const uploadImage = async () => {
    if (!validateImage()) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("image", state.file);
      const config = { headers: { "content-type": "multipart/form-data", Authorization: `Bearer ${auth.token}` } };
      const res = await axios.post("/api/profile/picture_upload", formData, config);
      if (res.status === 200) {
        const ff = res.data.avatar || res.data.filename;
        setErrors({});
        setUrlImage(is_url(ff));
        setState({ fileName: ff });
        await dispatch(loadUser({ data: { ...auth, avatar: ff } }));
        setOpenImg(false);
      } else {
        setErrors({ input_file: tr("Image upload failed.") });
      }
    } catch (err) {
      setErrors({ input_file: tr("Image upload failed.") });
      if (err.response) console.log(err.response);
    } finally {
      setUploading(false);
    }
  };

  // ── Close account ──
  const closeAccount     = async () => {
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } };
      const res = await axios.put("/api/profile/close_account", JSON.stringify({ email, workspace_id: auth.workspace_id }), config);
      if (res.status === 200) history("/logout");
    } catch (err) { if (err.response) console.log(err.response); }
  };
  const closeAccountOpen = () => SetOpenAccountmodal(false);

  // ── Chevron icon (inline, no extra dep) ──
  const ChevronDown = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );

  // ─────────────────────────────────────────────
  // RENDER
  // ─────────────────────────────────────────────
  return (
    <div>
      <SideBar />
      <div className="content-wrap" id="wrapper">
        <div className="main dashboard-bg">
          <div className="settings-page">

            {/* ── Page header ── */}
            <div className="settings-page-header">
              <h1>{tr("My Profile")}</h1>
              <p>{tr("Manage your personal information and preferences")}</p>
            </div>

            {/* ── Profile identity card ── */}
            <div className="st-card">
              <div className="st-workspace-card">

                {/* Avatar */}
                <div
                  className="st-logo-upload pf-avatar"
                  onClick={imgClick}
                  role="button"
                  aria-label={tr("Upload profile picture")}
                  tabIndex={0}
                  onKeyDown={(e) => e.key === "Enter" && imgClick()}
                >
                  {state.fileName ? (
                    <>
                      <img
                        src={profileImageSrc(state.fileName)}
                        alt={tr("Your profile picture")}
                      />
                      <div className="st-logo-overlay">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                          <circle cx="12" cy="13" r="4" />
                        </svg>
                      </div>
                    </>
                  ) : (
                    <>
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                      </svg>
                      <span>{tr("Upload photo")}</span>
                    </>
                  )}
                </div>

                {/* Name + Email + Country */}
                <div className="st-workspace-info pf-info-fields">
                  <label htmlFor="pf-name">{tr("Full name")}</label>
                  <input
                    id="pf-name"
                    type="text"
                    className="st-workspace-input"
                    value={profile_name}
                    onChange={(e) => setProfileName(e.target.value)}
                    onBlur={changeName}
                    placeholder={tr("First Last")}
                  />
                  {errors.profile_name && <div className="st-input-error">{tr(errors.profile_name)}</div>}
                  {nameSaved && <div className="st-input-success">{tr("Name saved")}</div>}

                  <label htmlFor="pf-email" style={{ marginTop: 18 }}>{tr("Email address")}</label>
                  <input
                    id="pf-email"
                    type="email"
                    className="st-workspace-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={tr("you@example.com")}
                  />
                  {errors.email && <div className="st-input-error">{tr(errors.email)}</div>}
                  {email.trim() !== savedEmail && (
                    <>
                      <label htmlFor="pf-email-password" style={{ marginTop: 12 }}>{tr("Current password")}</label>
                      <input
                        id="pf-email-password"
                        type="password"
                        className="st-workspace-input"
                        value={emailPassword}
                        onChange={(e) => setEmailPassword(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && changeEmail()}
                        placeholder={tr("Confirm with your current password")}
                        autoComplete="current-password"
                      />
                      {errors.emailPassword && <div className="st-input-error">{tr(errors.emailPassword)}</div>}
                      <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
                        <button type="button" className="st-upload-btn" onClick={changeEmail}>{tr("Save email")}</button>
                        <button
                          type="button"
                          className="pf-cancel-btn"
                          onClick={() => {
                            setEmail(savedEmail);
                            setEmailPassword("");
                            setErrors((prev) => ({ ...prev, email: undefined, emailPassword: undefined }));
                          }}
                        >{tr("Cancel")} </button>
                      </div>
                    </>
                  )}
                  {emailSaved && <div className="st-input-success">{tr("Email saved")}</div>}

                  <label style={{ marginTop: 18 }}>{tr("Country")}</label>
                  <div className="st-select-wrap" ref={countryRef} style={{ maxWidth: 320 }}>
                    <div
                      className={`st-select-trigger${openCountry ? " open" : ""}`}
                      onClick={() => { setOpenCountryList(!openCountry); if (!openCountry) setCountrySearch(""); }}
                      role="combobox"
                      aria-expanded={openCountry}
                      aria-label={tr("Select country")}
                      tabIndex={0}
                      onKeyDown={(e) => e.key === "Enter" && setOpenCountryList(!openCountry)}
                    >
                      <span>{country || tr("Select country")}</span>
                      <ChevronDown />
                    </div>
                    <div className={`st-select-dropdown pf-country-dropdown${openCountry ? " open" : ""}`}>
                      <div className="pf-tz-search-wrap">
                        <input
                          type="text"
                          className="pf-tz-search"
                          placeholder={tr("Search country…")}
                          value={countrySearch}
                          onChange={(e) => setCountrySearch(e.target.value)}
                        />
                      </div>
                      <div className="pf-tz-options">
                        {filteredCountries.map((item, i) => (
                          <div
                            key={i}
                            className={`st-select-option${country === item.country_name ? " selected" : ""}`}
                            onClick={() => { selectCountry(item); setCountrySearch(""); }}
                          >
                            {item.country_name}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ── Section label ── */}
            <div className="st-section-label">{tr("Personal Preferences")}</div>

            {/* ── Time & Date card ── */}
            <div className="st-card">
              <div className="st-card-row">
                <div className="st-card-left">
                  <h3>{tr("Time & Date")}</h3>
                  <p>{tr("How times and dates appear across the app")}</p>
                </div>
                <div className="st-card-right">

                  {/* Timezone */}
                  <div className="st-radio-group">
                    <div className="st-radio-label">{tr("Timezone")}</div>
                    <div className="st-select-wrap" ref={tzRef}>
                      <div
                        className={`st-select-trigger${openZoneDD ? " open" : ""}`}
                        onClick={() => { selectOpenZone(!openZoneDD); if (!openZoneDD) setTzSearch(""); }}
                        tabIndex={0}
                        onKeyDown={(e) => e.key === "Enter" && selectOpenZone(!openZoneDD)}
                      >
                        <span className="pf-tz-value">{timeZone || tr("Select timezone")}</span>
                        <ChevronDown />
                      </div>
                      <div className={`st-select-dropdown pf-tz-dropdown${openZoneDD ? " open" : ""}`}>
                        <div className="pf-tz-search-wrap">
                          <input
                            type="text"
                            className="pf-tz-search"
                            placeholder={tr("Search timezone…")}
                            value={tzSearch}
                            onChange={(e) => setTzSearch(e.target.value)}
                          />
                        </div>
                        <div className="pf-tz-options">
                          {filteredZones.slice(0, 150).map((item, i) => (
                            <div
                              key={i}
                              className={`st-select-option${item.label === timeZone ? " selected" : ""}`}
                              onClick={() => selectTimeZone(item)}
                            >
                              {item.label}
                            </div>
                          ))}
                        </div>
                        {filteredZones.length > 150 && (
                          <div className="pf-tz-more">
                            {filteredZones.length - 150} {tr("more — type to filter")} </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Duration format */}
                  <div className="st-radio-group">
                    <div className="st-radio-label">{tr("Duration display format")}</div>
                    <div className="st-select-wrap" ref={durationRef}>
                      <div
                        className={`st-select-trigger${openTimeDurationDD ? " open" : ""}`}
                        onClick={() => setTimeDurationDD(!openTimeDurationDD)}
                        tabIndex={0}
                        onKeyDown={(e) => e.key === "Enter" && setTimeDurationDD(!openTimeDurationDD)}
                      >
                        <span>{tr(timeDurationFormat) || tr("Select format")}</span>
                        <ChevronDown />
                      </div>
                      <div className={`st-select-dropdown${openTimeDurationDD ? " open" : ""}`}>
                        {durationFormat.map((item, i) => (
                          <div
                            key={i}
                            className={`st-select-option${item === timeDurationFormat ? " selected" : ""}`}
                            onClick={() => selectTimeDuration(item)}
                          >
                            {tr(item)}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Date format */}
                  <div className="st-radio-group">
                    <div className="st-radio-label">{tr("Date format")}</div>
                    <div className="st-select-wrap" ref={dateFormatRef} style={{ maxWidth: 220 }}>
                      <div
                        className={`st-select-trigger${openDateFormatDD ? " open" : ""}`}
                        onClick={() => setDateFormatDD(!openDateFormatDD)}
                        tabIndex={0}
                        onKeyDown={(e) => e.key === "Enter" && setDateFormatDD(!openDateFormatDD)}
                      >
                        <span>{dateFormat || tr("Select format")}</span>
                        <ChevronDown />
                      </div>
                      <div className={`st-select-dropdown${openDateFormatDD ? " open" : ""}`}>
                        {dateformats.map((item, i) => (
                          <div
                            key={i}
                            className={`st-select-option${item === dateFormat ? " selected" : ""}`}
                            onClick={() => selectDateFormat(item)}
                          >
                            {tr(item)}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <LanguageSelector />
                  {/* Time format */}
                  <div className="st-radio-group">
                    <div className="st-radio-label">{tr("Time format")}</div>
                    <div className="st-select-wrap" ref={timeFormatRef} style={{ maxWidth: 180 }}>
                      <div
                        className={`st-select-trigger${openTimeFormatDD ? " open" : ""}`}
                        onClick={() => setTimeFormatDD(!openTimeFormatDD)}
                        tabIndex={0}
                        onKeyDown={(e) => e.key === "Enter" && setTimeFormatDD(!openTimeFormatDD)}
                      >
                        <span>{tr(timeFormat) || tr("Select format")}</span>
                        <ChevronDown />
                      </div>
                      <div className={`st-select-dropdown${openTimeFormatDD ? " open" : ""}`}>
                        {timeFormats.map((item, i) => (
                          <div
                            key={i}
                            className={`st-select-option${item === timeFormat ? " selected" : ""}`}
                            onClick={() => selectTimeFormat(item)}
                          >
                            {tr(item)}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* First day of week */}
                  <div className="st-radio-group" style={{ marginBottom: 0 }}>
                    <div className="st-radio-label">{tr("First day of the week")}</div>
                    <div className="st-select-wrap" ref={firstDayRef} style={{ maxWidth: 180 }}>
                      <div
                        className={`st-select-trigger${openFirstDayDD ? " open" : ""}`}
                        onClick={() => setFirstDayDD(!openFirstDayDD)}
                        tabIndex={0}
                        onKeyDown={(e) => e.key === "Enter" && setFirstDayDD(!openFirstDayDD)}
                      >
                        <span>{tr(days[firstDay]) || tr("Select day")}</span>
                        <ChevronDown />
                      </div>
                      <div className={`st-select-dropdown${openFirstDayDD ? " open" : ""}`}>
                        {days.map((item, i) => (
                          <div
                            key={i}
                            className={`st-select-option${i === firstDay ? " selected" : ""}`}
                            onClick={() => selectFirstDay(item, i)}
                          >
                            {tr(item)}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            {/* ── Notifications card ── */}
            <div className="st-card">
              <div className="st-card-row">
                <div className="st-card-left">
                  <h3>{tr("Notifications")}</h3>
                  <p>{tr("Choose which alerts and emails you'd like to receive")}</p>
                </div>
                <div className="st-card-right">

                  <div className="st-toggle-row">
                    <div className="st-toggle-wrap">
                      <ToggleButton selected={send_weekly_report} ariaLabel={tr("Weekly email report")} toggleSelected={weeklyReportChange} />
                    </div>
                    <div className="st-toggle-info">
                      <h4>{tr("Weekly email report")}</h4>
                      <p>{tr("Receive a summary of your tracked time every Monday")}</p>
                    </div>
                  </div>

                  <div className="st-toggle-row">
                    <div className="st-toggle-wrap">
                      <ToggleButton selected={send_daily_report} ariaLabel={tr("Daily email report")} toggleSelected={dailyReportChange} />
                    </div>
                    <div className="st-toggle-info">
                      <h4>{tr("Daily email report")}</h4>
                      <p>{tr("Receive a summary of yesterday's tracked time every morning at 8:00")}</p>
                    </div>
                  </div>

                  <div className="st-radio-group" style={{ marginTop: -4 }}>
                    <div className="st-radio-label">{tr("Daily report recipient")}</div>
                    <input
                      type="email"
                      className="st-workspace-input"
                      style={{ maxWidth: 340 }}
                      value={dailyReportEmail}
                      onChange={(e) => setDailyReportEmail(e.target.value)}
                      onBlur={saveDailyReportEmail}
                      onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); saveDailyReportEmail(); e.currentTarget.blur(); } }}
                      placeholder={tr("Account email (default)")}
                      aria-label={tr("Daily report recipient email")}
                    />
                    <div className="st-rate-hint">{dailyReportEmailSaved ? tr("Saved!") : tr("Leave blank to send the report to your account email.")}</div>
                  </div>

                  <div className="st-toggle-row">
                    <div className="st-toggle-wrap">
                      <ToggleButton selected={notification_long_run} ariaLabel={tr("Long-running timer alert")} toggleSelected={notificationChange} />
                    </div>
                    <div className="st-toggle-info">
                      <h4>{tr("Long-running timer alert")}</h4>
                      <p>{tr("Show an in-app notification when a timer has been running for over 6 hours")}</p>
                    </div>
                  </div>

                  <div className="st-toggle-row">
                    <div className="st-toggle-wrap">
                      <ToggleButton selected={long_run_email} ariaLabel={tr("Long-running timer email")} toggleSelected={longRunEmailChange} />
                    </div>
                    <div className="st-toggle-info">
                      <h4>{tr("Long-running timer email")}</h4>
                      <p>{tr("Send an email reminder when a timer has been running for over 6 hours")}</p>
                    </div>
                  </div>

                  <div className="st-toggle-row">
                    <div className="st-toggle-wrap">
                      <ToggleButton selected={send_news_letter} ariaLabel={tr("Product updates and newsletter")} toggleSelected={newsLetterChange} />
                    </div>
                    <div className="st-toggle-info">
                      <h4>{tr("Product updates & newsletter")}</h4>
                      <p>{tr("Occasional emails about new features and improvements to Minutezilla")}</p>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            {/* ── Timer page card ── */}
            <div className="st-card">
              <div className="st-card-row">
                <div className="st-card-left">
                  <h3>{tr("Timer page")}</h3>
                  <p>{tr("Preferences for your daily tracking workflow")}</p>
                </div>
                <div className="st-card-right">
                  <div className="st-toggle-row" style={{ borderBottom: "none", paddingBottom: 0 }}>
                    <div className="st-toggle-wrap">
                      <ToggleButton selected={is_group_similar} ariaLabel={tr("Group similar time entries")} toggleSelected={() => groupSimilarEntries(is_group_similar)} />
                    </div>
                    <div className="st-toggle-info">
                      <h4>{tr("Group similar time entries")}</h4>
                      <p>{tr("Entries with the same title on the same day are collapsed into one row")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ── Sign-in options card ── */}
            <div className="st-card">
              <div className="st-card-row">
                <div className="st-card-left">
                  <h3>{tr("Sign-in options")}</h3>
                  <p>{tr("Manage additional ways to sign in to your account")}</p>
                </div>
                <div className="st-card-right">
                  <div className="pf-signin-options">

                    {/* Google */}
                    <div className={`pf-signin-card${is_google_signin ? " active" : ""}`}>
                      <svg className="pf-signin-icon" width="22" height="22" viewBox="-2.5 -2.5 24 24">
                        <path fill="none" d="M-1-1h21v21H-1z" />
                        <g fill="none" fillRule="evenodd">
                          <path d="M18.14 9.705c0-.639-.057-1.252-.164-1.841H9.5v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4" />
                          <path d="M9.5 18.5c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H1.457v2.332A8.997 8.997 0 009.5 18.5z" fill="#34A853" />
                          <path d="M4.464 11.21a5.41 5.41 0 01-.282-1.71c0-.593.102-1.17.282-1.71V5.458H1.457A8.997 8.997 0 00.5 9.5c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05" />
                          <path d="M9.5 4.08c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.963 1.391 11.926.5 9.5.5a8.997 8.997 0 00-8.043 4.958L4.464 7.79C5.172 5.663 7.156 4.08 9.5 4.08z" fill="#EA4335" />
                        </g>
                      </svg>
                      <span className="pf-signin-label">Google</span>
                      <span className={`pf-signin-badge${is_google_signin ? " on" : ""}`}>
                        {is_google_signin ? tr("Enabled") : tr("Disabled")}
                      </span>
                      <button
                        className={`pf-signin-action${is_google_signin ? " danger" : ""}`}
                        onClick={() => manageAdditionalSignIn(1, is_google_signin)}
                      >
                        {is_google_signin ? tr("Disable") : tr("Enable")}
                      </button>
                    </div>

                    {/* Apple */}
                    <div className={`pf-signin-card${is_apple_signin ? " active" : ""}`}>
                      <svg className="pf-signin-icon" width="22" height="22" viewBox="16 14 24 24">
                        <g fill="none" fillRule="evenodd">
                          <path d="M28.223 20.385c.832 0 1.875-.58 2.496-1.353.562-.7.972-1.68.972-2.658 0-.132-.011-.265-.035-.374-.926.036-2.039.64-2.707 1.45-.527.615-1.008 1.582-1.008 2.572 0 .145.024.29.036.338.058.013.152.025.246.025zM25.293 35c1.137 0 1.64-.785 3.059-.785 1.441 0 1.757.76 3.023.76 1.242 0 2.074-1.183 2.86-2.342.878-1.33 1.242-2.634 1.265-2.694-.082-.024-2.46-1.027-2.46-3.841 0-2.44 1.874-3.54 1.98-3.624-1.243-1.836-3.13-1.884-3.645-1.884-1.395 0-2.531.87-3.246.87-.774 0-1.793-.822-3-.822-2.297 0-4.629 1.957-4.629 5.653 0 2.295.867 4.723 1.934 6.293.914 1.329 1.71 2.416 2.859 2.416z" fill="#000" fillRule="nonzero" />
                        </g>
                      </svg>
                      <span className="pf-signin-label">Apple</span>
                      <span className={`pf-signin-badge${is_apple_signin ? " on" : ""}`}>
                        {is_apple_signin ? tr("Enabled") : tr("Disabled")}
                      </span>
                      <button
                        className={`pf-signin-action${is_apple_signin ? " danger" : ""}`}
                        onClick={() => manageAdditionalSignIn(2, is_apple_signin)}
                      >
                        {is_apple_signin ? tr("Disable") : tr("Enable")}
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            {/* ── Section label ── */}
            <div className="st-section-label">{tr("Account")}</div>

            {/* ── Account actions card ── */}
            <div className="st-card">
              <div className="st-card-row">
                <div className="st-card-left">
                  <h3>{tr("Account actions")}</h3>
                  <p>{tr("Manage your password and account status")}</p>
                </div>
                <div className="st-card-right">
                  <div className="pf-account-actions">
                    <div className="pf-action-row">
                      <button className="st-upload-btn" onClick={() => setShow(true)}>{tr("Change password")} </button>
                      {passChanged && (
                        <span className="st-input-success" style={{ marginLeft: 12 }}>{tr("Password updated!")}</span>
                      )}
                    </div>
                    <div className="pf-action-row" style={{ marginTop: 12 }}>
                      <button className="pf-danger-btn" onClick={() => SetOpenAccountmodal(true)}>{tr("Close account")} </button>
                      <span className="pf-danger-hint">{tr("This action cannot be undone.")}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* ══════════════════════════════════════
            MODALS
            ══════════════════════════════════════ */}

        {/* Change password */}
        <Modal show={show} onHide={() => { setShow(false); setErrors({}); setPassword(""); setNewPass(""); setConfirmPass(""); }}>
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>{tr("Change Password")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="pf-pass-form">
              <div>
                <label htmlFor="pass-current" className="st-radio-label">{tr("Current password")}</label>
                <input
                  id="pass-current"
                  type="password"
                  className="st-workspace-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onBlur={() => password && validatePassword()}
                  autoComplete="current-password"
                />
                {errors.password && <div className="st-input-error">{tr(errors.password)}</div>}
              </div>
              <div>
                <label htmlFor="pass-new" className="st-radio-label">{tr("New password")}</label>
                <input
                  id="pass-new"
                  type="password"
                  className="st-workspace-input"
                  value={newPass}
                  onChange={(e) => setNewPass(e.target.value)}
                  onBlur={() => newPass && validatePassword()}
                  autoComplete="new-password"
                />
                {errors.newPass && <div className="st-input-error">{tr(errors.newPass)}</div>}
                <div className="pf-pass-hint">{tr("Min. 8 characters including uppercase, number and symbol (@#$%&)")}</div>
              </div>
              <div>
                <label htmlFor="pass-confirm" className="st-radio-label">{tr("Confirm new password")}</label>
                <input
                  id="pass-confirm"
                  type="password"
                  className="st-workspace-input"
                  value={confirmPass}
                  onChange={(e) => setConfirmPass(e.target.value)}
                  onBlur={() => confirmPass && validatePassword()}
                  autoComplete="new-password"
                />
                {errors.confirmPass && <div className="st-input-error">{tr(errors.confirmPass)}</div>}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ gap: 8 }}>
            <button className="pf-cancel-btn" onClick={() => { setShow(false); setErrors({}); setPassword(""); setNewPass(""); setConfirmPass(""); }}>{tr("Cancel")} </button>
            <button className="st-upload-btn" onClick={changePassword}>{tr("Save password")} </button>
          </Modal.Footer>
        </Modal>

        {/* Avatar upload */}
        <Modal show={openImg} onHide={closeImg} dialogClassName="modal-90w">
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>{tr("Upload profile picture")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isUploading && <Loader />}
            <div className="st-upload-area">
              <input
                type="file"
                name="myImage"
                accept="image/jpeg,image/jpg,image/png"
                onChange={onInputChange}
              />
              <p style={{ fontSize: 12, color: "var(--ti-muted)", marginTop: 8, marginBottom: 0 }}>{tr("JPEG or PNG, max 2 MB")} </p>
            </div>
            {errors.input_file && <div className="st-upload-error">{tr(errors.input_file)}</div>}
          </Modal.Body>
          <Modal.Footer>
            <button className="st-upload-btn" onClick={uploadImage}>{tr("Upload")}</button>
          </Modal.Footer>
        </Modal>

        {/* Close account */}
        <Modal show={openAccountModal} onHide={closeAccountOpen}>
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>{tr("Close account")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p style={{ fontSize: 14, color: "var(--ti-text)", marginBottom: 12 }}>{tr("Before you go, please note:")} </p>
            <ul style={{ fontSize: 14, color: "var(--ti-muted)", paddingLeft: 20, lineHeight: 2, margin: 0 }}>
              <li>{tr("You won't be able to reactivate your account.")}</li>
              <li>{tr("All data will be permanently deleted after 90 days.")}</li>
            </ul>
          </Modal.Body>
          <Modal.Footer style={{ gap: 8 }}>
            <button className="pf-cancel-btn" onClick={closeAccountOpen}>{tr("Cancel")}</button>
            <button className="pf-danger-btn" onClick={closeAccount}>{tr("Close my account")}</button>
          </Modal.Footer>
        </Modal>

        <Footer />
      </div>
    </div>
  );
}
